import AlertaGuardado from 'components/comun/AlertaGuardado';
import { apiUrl } from "config/runtimeConfig";
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Label, Row, Table } from 'reactstrap'
import { useAuth } from "context/AuthProvider";
import { apiInformesPeriodicosService } from "services/apiInformesPeriodicosService";
import { showAppAlert } from "components/common/AppAlerts";

function EnvioInformes() {

    const { empresa } = useAuth();
    const [emailDestino, setEmailDestino] = useState("");
    const [tipoInforme, setTipoInforme] = useState("FICHAJES");
    const [periodo, setPeriodo] = useState("DIARIO");
    const [configs, setConfigs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const tiposInformes = [
        { value: 'FICHAJES', label: 'Informe de fichajes' },
        { value: 'HORAS_FICHAJES', label: 'Informe de horas de fichajes' },
        { value: 'FICHAJES_COMPLETO', label: 'Informe de fichajes completo' },
    ];

    const periodicidad = [
        { value: 'DIARIO', label: 'Diario' },
        { value: 'SEMANAL', label: 'Semanal' },
        { value: 'MENSUAL', label: 'Mensual' },
    ];

    const tipoLabel = useMemo(() => {
        const map = new Map(tiposInformes.map(item => [item.value, item.label]));
        return (value) => map.get(value) || value;
    }, []);

    const periodicidadLabel = useMemo(() => {
        const map = new Map(periodicidad.map(item => [item.value, item.label]));
        return (value) => map.get(value) || value;
    }, []);

   
    const [status, setStatus] = useState("");
    const navigate = useNavigate();
    const handleReturn = () => {
        navigate("/admin/index")
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!empresa?.id) {
            setError("No se ha encontrado la empresa.");
            return;
        }
        setError("");
        setLoading(true);
        try {
            await apiInformesPeriodicosService.create({
                empresaId: empresa.id,
                tipoInforme,
                periodicidad: periodo,
                emailsDestino: emailDestino,
                activo: true
            });
            await loadConfigs();
            setStatus("saved");
            setTimeout(() => {
                setStatus("");
            }, 2000);
        } catch (err) {
            setError(err.message || "Error guardando la configuracion.");
            setStatus("error");
            setTimeout(() => {
                setStatus("");
            }, 2000);
        } finally {
            setLoading(false);
        }
    }

    const loadConfigs = async () => {
        if (!empresa?.id) {
            return;
        }
        setLoading(true);
        try {
            const data = await apiInformesPeriodicosService.getByEmpresa(empresa.id);
            setConfigs(data);
        } catch (err) {
            setError(err.message || "Error cargando los informes.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!id) {
            return;
        }
        setLoading(true);
        try {
            await apiInformesPeriodicosService.remove(id);
            await loadConfigs();
        } catch (err) {
            setError(err.message || "Error eliminando la configuracion.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadConfigs();
    }, [empresa?.id]);

    return (
        <>
            <Card>
                <CardHeader>Envio de informes</CardHeader>
                <CardBody>
                    <Row className="mb-3">
                        <Col>
                            {error ? <p className="text-danger mb-2">{error}</p> : null}
                            {loading ? <p className="text-muted mb-2">Cargando...</p> : null}
                            <Table responsive size="sm">
                                <thead>
                                    <tr>
                                        <th>Informe</th>
                                        <th>Periodicidad</th>
                                        <th>Emails</th>
                                        <th>Activo</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {configs.length === 0 ? (
                                        <tr>
                                            <td colSpan="5" className="text-center text-muted">No hay informes configurados.</td>
                                        </tr>
                                    ) : (
                                        configs.map((item) => (
                                            <tr key={item.id}>
                                                <td>{tipoLabel(item.tipoInforme)}</td>
                                                <td>{periodicidadLabel(item.periodicidad)}</td>
                                                <td>{item.emailsDestino || "-"}</td>
                                                <td>{item.activo ? "Si" : "No"}</td>
                                                <td className="text-right">
                                                    <Button
                                                        color="danger"
                                                        size="sm"
                                                        onClick={() => handleDelete(item.id)}
                                                        disabled={loading}
                                                    >
                                                        Eliminar
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Form>
                        <Row>
                            <Col>
                                <FormGroup>

                                    <Label for="informeNombre" className="form-control-label">Nombre del informe</Label>
                                    <Input
                                        type='select'
                                        name='informeNombre'
                                        id='informeNombre'
                                        value={tipoInforme}
                                        onChange={(e) => setTipoInforme(e.target.value)}
                                    >
                                        {tiposInformes.map((informe) => (
                                            <option key={informe.value} value={informe.value}>
                                                {informe.label}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>

                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>

                                    <Label for="periodicidad" className="form-control-label">Periodicidad</Label>
                                    <Input
                                        type='select'
                                        name='periodicidad'
                                        id='periodicidad'
                                        value={periodo}
                                        onChange={(e) => setPeriodo(e.target.value)}
                                    >
                                        {periodicidad.map((periodo) => (
                                            <option key={periodo.value} value={periodo.value}>
                                                {periodo.label}
                                            </option>
                                        ))}
                                    </Input>
                                    <p className='text-muted mt-2'>Todas las periodicidades se enviaran a las 23:59.</p>
                                </FormGroup>
                            </Col>

                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="emailDestino" className="form-control-label">Emails destino</Label>
                                    <Input
                                        type='text'
                                        name='emailDestino'
                                        id='emailDestino'
                                        placeholder="email1@empresa.com; email2@empresa.com"
                                        value={emailDestino}
                                        onChange={(e) => setEmailDestino(e.target.value)}
                                    />
                                    <p className='text-muted mt-2'>Separe multiples emails por coma o punto y coma.</p>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>

                            <Col className='text-right'>
                                <Button color='success' type='submit' onClick={handleSubmit} disabled={loading}>Guardar</Button>
                                <Button color='secondary' type='submit' onClick={handleReturn}>volver</Button>
                            </Col>
                        </Row>

                        
                    </Form>

                </CardBody>
            </Card>
            <AlertaGuardado status={status}></AlertaGuardado>
        </>
    )
}


export default EnvioInformes


